const tokenExpiry = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (payload.exp) return payload.exp * 1000 - 60000;
    if (payload.type === "privilege") return Number.MAX_SAFE_INTEGER;
  } catch {}
  return Date.now() + 11 * 3600 * 1000;
};

const notExpired = () => {
  const exp = Number(sessionStorage.getItem("gp_priv_exp") || 0);
  if (exp && Date.now() < exp) return true;
  clearPrivilege();
  return false;
};

const clearPrivilege = () => {
  sessionStorage.removeItem("gp_ozel_yetki");
  sessionStorage.removeItem("gp_priv_token");
  sessionStorage.removeItem("gp_priv_exp");
};

export const isPrivileged = () => sessionStorage.getItem("gp_ozel_yetki") === "1" && notExpired();

export const getPrivilegeToken = () => (notExpired() ? sessionStorage.getItem("gp_priv_token") : null);

export const hasPrivilege = () => isPrivileged() && !!sessionStorage.getItem("gp_priv_token");

export const setPrivileged = (v, token) => {
  if (v) {
    sessionStorage.setItem("gp_ozel_yetki", "1");
    if (token) {
      sessionStorage.setItem("gp_priv_token", token);
      sessionStorage.setItem("gp_priv_exp", String(tokenExpiry(token)));
    }
  } else {
    clearPrivilege();
  }
};
